import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {Log, LogTag} from '../../services/Log';
import {Observable, of, switchMap} from 'rxjs';
import {PlayerList} from "../../player/player.list";
import {map} from "rxjs/operators";
import {DS_API_URL} from "../../constants";

@Component({
  selector: 'app-json-list',
  template: `
    <div #component>
      <template #playercontainer></template>
      <ngx-flicking #flk [options]=options>
          <app-flicking-item flicking-panel *ngFor="let page of pages" class="flicking-panel"
                       [setParentPlayer]="this"
                       [setEditMode]="editMode"
                       [setPage]="page">
          </app-flicking-item>
      </ngx-flicking>
    </div>`,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AyreshareComponent extends PlayerList {
  constructor(protected  injector: Injector) {
    super(injector);
  }

  urlParam;
  itemsPath;

  getConfig() { return this.data.Json[0].$; }
  getScene() { return this.data.Json[0].Player[0]; }


  load(playerObject: any): Observable<any> {
    const metadata = playerObject.Data[0].DataProvider[0].$.metadata;
    switch (metadata) {
      case 'Json.facebook': // 6300
        this.urlParam = 'facebook';
        this.itemsPath = 'posts';
        break;
      case 'Json.facebook.groups': // 6305  //??? there is no data in API
        this.urlParam = 'fbg';
        this.itemsPath = 'posts';
        break;
      case 'Json.google.business': // 6310  not working???
        this.urlParam = 'gmb';
        this.itemsPath = 'posts';
        break;
      case 'Json.instagram': // 6315 not working ???
        this.urlParam = 'instagram';
        this.itemsPath = 'posts';
        break;
      case 'Json.linkedin': // 6320 // not working
        this.urlParam = 'linkedin';
        this.itemsPath = 'posts';
        break;
      case 'Json.pinterest': // 6325 // not working
        this.urlParam = 'pinterest';
        this.itemsPath = 'posts';
        break;
      case 'Json.reddit': //6330  // not working
        this.urlParam = 'reddit';
        this.itemsPath = 'posts';
        break;
      case 'Json.telegram': //6335  // not working
        this.urlParam = 'telegram';
        this.itemsPath = 'posts';
        break;
      case 'Json.tiktok': // 6340 works
        this.urlParam = 'tiktok';
        this.itemsPath = 'posts';
        break;
      case 'Json.x': // 6345 works
        this.urlParam = 'x';
        this.itemsPath = 'posts';
        break;
      case 'Json.youtube': // 6350
        this.urlParam = 'youtube';
        this.itemsPath = 'posts';
        break;
    }


    return super.load(playerObject);
  }


  loadProviderData(): Observable<any> {
    return this.playerService.getAyreshareToken().pipe(
      switchMap( token => {
        this.url = DS_API_URL + 'socialFeed/'+token+'/'+ this.urlParam;
        return this.playerService.loadProviderData(null, 'external', this.url, 'ayreshare');
      }),
      map(res => {
        return res[this.itemsPath]
      })
    )
  }
}
